<template>
  <div class="hero">
    <div style="height:100%" :style="largeScreenContainer">
      <v-container fill-height>
        <v-row style="height:100%" no-gutters>
          <v-col cols="12" md="6" style="height:100%">
            <div class="hero-left" style="height:100%">
              <h1 class="hero-title">
                Lorem ipsum dolor sit
              </h1>
              <div class="hero-desc">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, Lorem
                ipsum dolor sit amet, consetetur sadipscing elitr, Lorem ipsum
                dolor sit amet, consetetur sadipscing elitr, Lorem ipsum dolor
                sit amet, consetetur sadipscing elitr, Lorem ipsum dolor sit
                amet, consetetur sadipscing elitr
              </div>
              <v-btn color="#600DFF" class="hero-cta white--text" elevation="0">
                Get Started
              </v-btn>
              <div class="hero-footer">
                <span class="mr-2">Excellent</span>
                <IconStarsMobile v-if="$vuetify.breakpoint.smAndDown" />
                <IconStars v-else />
                <span class="mx-1">7,000+ reviews on </span>
                <IconStar />
                <span class="ml-1">Truspilot </span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="hero-right">
              <div class="hero-right-img">
                <img src="@/assets/img/hero-img.jpg" alt="" />
                <div class="hero-right-item hero-right-item-1">
                  <IconHeroItem1 />
                  <span>Proposal sent! </span>
                </div>
                <div class="hero-right-item hero-right-item-2">
                  <IconHeroItem2 />
                  <span>New order! 🎉 </span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import IconStars from "@/components/icons/IconStars";
import IconStarsMobile from "@/components/icons/IconStarsMobile";
import IconStar from "@/components/icons/IconStar";
import IconHeroItem1 from "@/components/icons/IconHeroItem1";
import IconHeroItem2 from "@/components/icons/IconHeroItem2";
export default {
  components: {
    IconStars,
    IconStarsMobile,
    IconStar,
    IconHeroItem1,
    IconHeroItem2,
  },
};
</script>

<style lang="scss">
.hero {
  background-color: #f2eee8;
  height: 100vh;
  margin-top: -116px;

  &-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
  }

  &-right {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
    &-img {
      position: relative;
    }
    &-item {
      position: absolute;
      height: 70px;
      border-radius: 8px;
      width: 270px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffff;
      position: absolute;
      right: 0;
      border: 1px solid #dadada;

      span {
        margin-left: 35px;
        font-size: 20px;
        font-weight: 700;
      }

      &-1 {
        top: 50px;
        right: -40px;
      }
      &-2 {
        top: 150px;
        right: -80px;
      }
    }
    img {
      height: 510px;
    }
  }

  &-title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 16px;
  }
  &-desc {
    font-size: 16px;
    color: #575452;
    margin-bottom: 16px;
    max-width: 390px;
    line-height: 1.75;
  }

  &-cta {
    height: 36px;
    margin-bottom: 30px;
    width: 380px;
    color: #fff;
    display: inline-block;

    span {
      text-transform: none;
    }
  }

  &-inner {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-footer {
    display: flex;
    align-items: center;

    span {
      color: #000;
      font-weight: 500;
    }
  }
}

@include smMax {
  .container {
    padding: 24px;
  }
  .hero {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 150px;
    &-cta {
      width: 100%;
    }
    &-title {
      font-size: 28px;
      margin: 0 auto;
    }
    &-desc {
      margin-top: 16px;
      margin-bottom: 10px;
      font-size: 16px;
      text-align: center;
      line-height: 30px;
    }
    &-right {
      margin-top: 40px;
      align-items: center;
      &-item {
        height: 72px;
      }
      &-item-1 {
        bottom: -42px;
        top: auto;
        right: 20px;
      }
      &-item-2 {
        top: -12px;
        right: -18px;
      }
      &-img {
      }
      img {
        height: 303px;
      }
    }
    &-footer {
      font-size: 11px;
      text-align: center;
      margin: 0 auto;
    }
  }
}
</style>
